import { render, staticRenderFns } from "./PartnersNewPartner.vue?vue&type=template&id=3c228361&"
import script from "./PartnersNewPartner.vue?vue&type=script&lang=js&"
export * from "./PartnersNewPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports